<script>
    import FooterAbout from '@/components/footer-about';
    import FooterLink from '@/components/footer-link';
    import ContactWidget from '@/components/kontak-widget';
    import SocialWidget from '@/components/social-widget';

    import data from '../data/footer.json'
    export default {
        components: {
            FooterAbout,
            FooterLink,
            ContactWidget,
            SocialWidget
        },
        props: ['bgFooter'],
        data () {
            return {
                data
            }
        }
    };
</script>
<template>
    <div class="footer-area" :class="bgFooter">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="footer-content-wrapper section-space--inner--60">
                        <div class="row">
                            <div class="col-xl-4 col-lg-3 col-md-4">
                                <FooterAbout :data="data.quote" />
                            </div>
                            <div class="col-xl-4 col-lg-3 col-md-4">
                                <ContactWidget :data="data.alamat" />
                            </div>
                             <div class="col-xl-4 col-lg-3 col-md-4">
                                <SocialWidget :data="data.social_media" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copyright-wrapper">
            <div class="footer-copyright text-center">
                 © Copyright SMA Negeri Indonesia All right reserved
            </div>
             <div class="footer-copyright text-center">
                 Designed By Onklas
            </div>
        </div>
    </div>
</template>

<style lang="scss">

</style>